class SlideshowSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setSlider();
  }

  setSlider() {
    // console.log(this.dataset.autoplay);
    // console.log(this.dataset.speed);
    
    let swiperSettings;
    if (this.dataset.autoplay == 'true') {
      // Define Swiper settings in a separate object
      swiperSettings = {
        // Optional parameters
        loop: true,
        // grabCursor: true,
        autoplay: {
          delay: parseInt(this.dataset.speed),
       },
        
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      };
    } else {
      // Define Swiper settings in a separate object
      swiperSettings = {
        // Optional parameters
        loop: true,
        slidesPerView: 1,
        // grabCursor: true,
        
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        
      };
    }
    
    const swiper = new Swiper(`#Slider-${this.dataset.sectionId}`, swiperSettings);
  }
}
customElements.define('slideshow-section', SlideshowSection);